/** Normaliza texto para comparar categorías (sin tildes, mayúsculas). */
function categoriaKey(value) {
  return String(value || '')
    .trim()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toUpperCase();
}

const CATEGORIA_ES_PLURAL = {
  VENEER: 'LAMINAS',
  LAMINA: 'LAMINAS',
  LAMINAS: 'LAMINAS',
  WOOD: 'MADERAS',
  MADERA: 'MADERAS',
  MADERAS: 'MADERAS',
  PLYWOOD: 'TERCIADOS',
  TERCIADO: 'TERCIADOS',
  TERCIADOS: 'TERCIADOS',
};

/** Categoría de producto en español plural para columna Etiqueta PTB (ej. Lamina → LAMINAS). */
export function etiquetaPtbCategoriaEspanolPlural(nombre) {
  const key = categoriaKey(nombre);
  if (!key) return '';
  if (CATEGORIA_ES_PLURAL[key]) return CATEGORIA_ES_PLURAL[key];
  if (key.endsWith('S')) return key;
  if (key.endsWith('A') || key.endsWith('E') || key.endsWith('O')) return `${key}S`;
  return key;
}

function matchCategoriaEnTexto(texto, categorias) {
  const upper = categoriaKey(texto);
  if (!upper) return '';
  const cats = (categorias || [])
    .map((cat) => ({
      nombre: String(cat?.nombre || '').trim(),
      ingles: String(cat?.nombre_ingles || '').trim(),
    }))
    .filter((cat) => cat.nombre || cat.ingles)
    .sort(
      (a, b) =>
        categoriaKey(b.ingles || b.nombre).length - categoriaKey(a.ingles || a.nombre).length
    );
  for (const cat of cats) {
    const en = categoriaKey(cat.ingles);
    const es = categoriaKey(cat.nombre);
    if (en && upper.includes(en)) return cat.nombre || cat.ingles;
    if (es && upper.includes(es)) return cat.nombre || cat.ingles;
  }
  return '';
}

/** Etiqueta PTB desde descripción / nombre de producto (fallback sin PI). */
export function etiquetaPtbFromDescription(productDescriptionSnapshot, productName, categorias = []) {
  const head = String(productDescriptionSnapshot || '').trim() || String(productName || '').trim();
  if (!head) return '';

  const fromCatalog = matchCategoriaEnTexto(head, categorias);
  if (fromCatalog) return etiquetaPtbCategoriaEspanolPlural(fromCatalog);

  const upperHead = categoriaKey(head);
  if (/\bVENEER\b/.test(upperHead)) return etiquetaPtbCategoriaEspanolPlural('VENEER');

  const parts = upperHead.split(/\s+/).filter(Boolean);
  return etiquetaPtbCategoriaEspanolPlural(parts[parts.length - 1] || upperHead);
}
